import getWindow from './get-window'

import { appName } from '~/../__config__/env.json'

export const track = (action, label, value, callback, nonInteractive) => {
  return getWindow().dataLayer
    ? getWindow().dataLayer.push({
        event: 'gaTriggerEvent',
        gaEventCategory: appName,
        gaEventAction: action,
        gaEventLabel: label,
        gaEventValue: value,
        eventCallback: callback,
        gaNonInteractive: nonInteractive || 0
      })
    : console.log('gaEvent', { type: appName, action, label, value, callback, nonInteractive })
}

export const datalayerPush = (data) => {
  const w = getWindow()
  w.dataLayer && w.dataLayer.push(data)
}

export const fullStoryExperimentUserFilter = (experimentName, cohort) => {
  getWindow().FS &&
    getWindow().FS.setUserVars({
      experimentValue_str: `${experimentName}-${cohort}`
    })
}

export const fullStoryEventFilter = (eventName) => {
  getWindow().FS && getWindow().FS.event(eventName)
}

export const trackSegment = (event, properties) => {
  const nerdalytics = getWindow().nerdalytics

  nerdalytics && nerdalytics.track(event, properties, () => {})
}

export const addDestinationFilterForEvents = (events) => {
  const w = getWindow()
  w.nerdEvents.addDestinationFilter(({ payload, context, destinations, skip }) => {
    if (events.includes(destinations.segment.getEventName(payload.name, payload.nerdAttributes))) {
      return [destinations.segment]
    }

    return skip()
  })
}
